import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import NationalityEditor from "../../editors/personInfo/nationality";

const Nationalities: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.NationalitiesList}
			endpoint={Endpoint.Nationalities}
			addScreen={{ screen: NationalityEditor, isAllowed: hasPermission(Permission.NationalitiesAdd) }}
			editScreen={{ screen: NationalityEditor, isAllowed: hasPermission(Permission.NationalitiesUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.NationalitiesDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default Nationalities;
